// Incident Selectors

export const getIncidentList = (state) => {
  const list = state.incident.get("incidentList");
  if (!list) return null;
  // Convert Immutable to JS if needed
  if (list && typeof list.toJS === "function") {
    return list.toJS();
  }
  return list;
};
export const getIncidentListLoading = (state) =>
  state.incident.get("incidentListLoading");
export const getIncidentListError = (state) =>
  state.incident.get("incidentListError");

export const getIncidentDashboard = (state) => {
  const dashboard = state.incident.get("incidentDashboard");
  if (!dashboard) return null;
  // Convert Immutable to JS if needed
  if (dashboard && typeof dashboard.toJS === "function") {
    return dashboard.toJS();
  }
  return dashboard;
};
export const getIncidentDashboardLoading = (state) =>
  state.incident.get("incidentDashboardLoading");

export const getIncidentDetail = (state) => {
  try {
    const detail = state.incident.get("incidentDetail");

    // Return null if detail is falsy
    if (!detail) {
      return null;
    }

    if (detail && typeof detail.toJS === "function") {
      return detail.toJS();
    }
    return detail;
  } catch (error) {
    return null;
  }
};
export const getIncidentDetailLoading = (state) =>
  state.incident.get("incidentDetailLoading");

export const getIncidentCreateLoading = (state) =>
  state.incident.get("incidentCreateLoading");
export const getIncidentCreateSuccess = (state) =>
  state.incident.get("incidentCreateSuccess");
export const getCreatedIncident = (state) => {
  const incident = state.incident.get("createdIncident");
  if (!incident) return null;
  if (incident && typeof incident.toJS === "function") {
    return incident.toJS();
  }
  return incident;
};

export const getIncidentUpdateLoading = (state) =>
  state.incident.get("incidentUpdateLoading");
export const getIncidentUpdateSuccess = (state) =>
  state.incident.get("incidentUpdateSuccess");
export const getUpdatedIncident = (state) => {
  const incident = state.incident.get("updatedIncident");
  if (!incident) return null;
  if (incident && typeof incident.toJS === "function") {
    return incident.toJS();
  }
  return incident;
};

export const getIncidentInvestigateLoading = (state) =>
  state.incident.get("incidentInvestigateLoading");
export const getIncidentInvestigateSuccess = (state) =>
  state.incident.get("incidentInvestigateSuccess");

export const getIncidentCloseLoading = (state) =>
  state.incident.get("incidentCloseLoading");
export const getIncidentCloseSuccess = (state) =>
  state.incident.get("incidentCloseSuccess");

export const getIncidentCloseDraftLoading = (state) =>
  state.incident.get("incidentCloseDraftLoading");
export const getIncidentCloseDraftSuccess = (state) =>
  state.incident.get("incidentCloseDraftSuccess");

export const getIncidentExportLoading = (state) =>
  state.incident.get("incidentExportLoading");

export const getAssignedParticipants = (state) =>
  state.incident.get("assignedParticipants");
export const getAssignedParticipantsLoading = (state) =>
  state.incident.get("assignedParticipantsLoading");
export const getAssignedParticipantsError = (state) =>
  state.incident.get("assignedParticipantsError");

// Delete selectors
export const getIncidentDeleteLoading = (state) =>
  state.incident.get("incidentDeleteLoading") || false;
export const getIncidentDeleteSuccess = (state) =>
  state.incident.get("incidentDeleteSuccess") || false;
export const getIncidentDeleteError = (state) =>
  state.incident.get("incidentDeleteError") || "";

// Bulk PDF Generate selectors
export const getBulkPdfGenerateLoading = (state) =>
  state.incident.get("bulkPdfGenerateLoading") || false;
export const getBulkPdfGenerateSuccess = (state) => {
  const success = state.incident.get("bulkPdfGenerateSuccess");
  if (!success) return null;
  // Redux may store Immutable.Map; toJS() for plain object
  if (success && typeof success.toJS === "function") {
    return success.toJS();
  }
  return success;
};
export const getBulkPdfGenerateError = (state) =>
  state.incident.get("bulkPdfGenerateError") || "";
